export default __webpack_public_path__ + "static/media/question_ikon.f34ed30a.png";